const en = {
  nav: {
    services: 'Services',
    about: 'About us',
    references: 'Projects',
    contact: 'Contact',
    cta: 'Hola! →',
  },
  hero: {
    kicker: 'Studio for Design & Text',
    tagline: 'Because with us, you have time for what really matters',
    cta1: "Let's talk →",
    cta2: 'Our Services',
    marquee: 'good design and text for you from buenas  ·  ',
  },
  intro: {
    kicker: '#bettertogether',
    h2line1: 'Studio for Design & Text',
    h2line2: '',
    subheadline: 'good. better. buenas.',
    p1: 'We are Eva · graphic designer, Christina · copywriter and Agustín · IT guru. And a team of experienced tech and online marketing experts. We love design, words and technology. The digital world and analog life. We write powerful copy, design and develop stunning brand and web design, social media content, ads and print products. For everyone who seeks the extraordinary.',
    p2: '',
    p3: '',
    button: 'More about us →',
  },
  services: {
    kicker: '#buenasideas',
    h2: 'What we do',
    intro:
      'We combine graphic design, copy, and technology. Together we create extraordinary brand and customer experiences. We develop, design, and code digital and analog products and platforms that also look really great. From the unique print magazine to modern web design to specific software – individual, creative, and professional.',
    col1: {
      title: 'Graphics & Design',
      items: [
        'Corporate Identity',
        'Corporate Design',
        'Logo Design',
        'Web, App & Screen Design',
        'Print Design & Layout',
        'Magazines & Brochures',
        'Ad & Content Design',
        'Packaging Design',
      ],
      link: 'Learn more →',
    },
    col2: {
      title: 'Copy & Words',
      items: [
        'Corporate Wording',
        'Website & App Copy',
        'Storytelling',
        'Advertising & Magazine Copy',
        'Ad & Campaign Copy',
        'Content Marketing',
        'Slogans & Claims',
        'SEO Copy',
      ],
      link: 'Learn more →',
    },
    col3: {
      title: 'Software & Development',
      items: [
        'Mobile, Web & App Development',
        'Digital Products & Platforms',
        'Software Development',
        'Responsive Design',
        'Landing Pages',
        'Corporate Websites',
        'Interfaces & Databases',
        'E-Commerce & Online Shops',
      ],
      link: 'Learn more →',
    },
    panel:
      'Brand Development · Branding · Packaging · Print & Digital · Web Design · AI & Software · Social Media · Content Marketing · Paid Advertising',
  },
  team: {
    kicker: '#buenaspersonas',
    h2: 'Who we are',
    moreLabel: 'learn more',
    lessLabel: 'less',
    intro:
      'We are young, wild and free – okay, maybe not that young anymore. But we still feel that way. We are a group of creatives who love what they do. The slightly different agency, where everyone is an expert in their field. We are bold, motivated and experienced. Analog and digital creatives. Loveable geeks. Buenas Personas. You can hire us individually or as a team. Online and personal.',
    eva: {
      role: 'Graphic Designer',
      bio: 'If you need a stunning visual identity with logo and colour concept: Eva is our graphic and design expert. She develops and improves your corporate and web design, your print and online media as well as your packaging design. She loves clean, reduced and elegant designs and has an exceptionally good eye for details.',
      more: 'Eva is Christina\'s twin sister, married to her childhood sweetheart and lives with her cat "Happy" in Hard on the beautiful Lake Constance. Travel is one of her passions, just like padel, yoga, art and culture. She is an exceptionally good listener and connects well with others. This allows her to create unique designs that perfectly match you and your products and technologies.',
      badge: 'good design by eva',
      quote: '»Good design is as little design as possible«',
    },
    christina: {
      role: 'Copywriter',
      bio: "When you're lost for words and need inspiring, authentic copy: Christina is a trained journalist and copywriter. She has been working in the marketing and communications industry for over 15 years and went freelance more than 5 years ago. She writes copy and concepts that move and is passionate about your stories.",
      more: "Christina is a creative thinker, traveller and someone who thinks outside the box. The Andorra-by-choice resident is humorous, laid-back and a little #crazy. She loves the southern way of life, Mediterranean food, but also Austrian cosiness. She moves a lot – playing padel, yoga, hiking or skiing. That's where she finds inspiration and ideas for writing.",
      badge: 'good copy by christina',
      quote: '»Writing is magic made visible«',
    },
    agustin: {
      role: 'Software Developer',
      bio: 'If you need a website or software: Agustín is our Senior Full-Stack Developer. He takes care of your back- and front-end and masters AI tools as well as all programming languages. He is also an expert in cybersecurity. In his initial graphic design training, he learned what matters when it comes to design and usability.',
      more: "Agus doesn't know problems, he always thinks in solutions. He is Argentinian and Spanish, lives in Andorra and when he's not coding with our other developers, you'll usually find him on his road bike or the padel court. He loves the simple things in life: sport, pizza, pasta, ice cream, coffee, sunshine, cumbia and of course the national drink of Argentina, his mate.",
      badge: 'good solutions by agus',
      quote: "»Don't look for mistakes, look for solutions«",
    },
    belowCards:
      '… and our team of experienced <strong>tech experts</strong> and <strong>online marketing specialists</strong>, spread across the globe. Online, but always personal.',
  },
  quote: {
    text: '»There is always a solution.\nFind one, create one, or\nask others for one.«',
    author: '— Tom Bilyeu',
    cta: 'Let us find your solution →',
  },
  referenzen: {
    kicker: '#buenasprojects',
    h2: 'Who we work with',
    intro:
      "We work with a variety of companies, freelancers, agencies and creatives from many different fields. We don't think in boxes – we're open to new ideas. But also to tried-and-true approaches, disruptive concepts and sustainable thinking. Our motto: if you can imagine it, you can make it. For companies, brands, hotels, industry and lifestyle.",
    moreLink: 'More Projects',
    lessLink: 'Show less',
    badge: 'With Winder&Wild',
    placeholder:
      "Our references and projects are coming soon. More to follow. (Spoiler: It's going to be pretty BUENAS.)",
    projects: [
      {
        name: 'Hotel Birkenhof · Oberstaufen, Allgäu',
        category: 'Brand Design · Web Design · Web Copy · Wording · Newsletter',
      },
      {
        name: 'Hotel Helvetia · Lindau, Bodensee',
        category: 'Brand Design · Wording · Merchandising · Brochure · Copy',
      },
      {
        name: 'Physiomed · Eislingen',
        category: 'Brand Design · Logo Design · Business Stationery',
      },
      { name: 'Studio Mint · Maria Jussel', category: 'Brand Voice · Storytelling · Web Copy' },
      {
        name: 'Damüls Faschina Tourismus',
        category: 'Magazinreihe · Interviews · Texte · Storytelling',
      },
      {
        name: 'Jean & Jacques Ice Cream Manufactory',
        category: 'Branding · Design · Packaging · Wording · Web Copy',
      },
    ],
  },
  twinPower: {
    kicker: '#goodenergy',
    h2: 'Why Buenas?',
    text: 'Because "Buenas" is more than a greeting. It stands for good energy, good conversations and great collaboration. That\'s exactly how we work. Eva, Christina, Agustín and our team. Creative minds with a shared vision: we support companies with great ideas, great design and great copy. Strong brands that have a unique voice.',
    button: 'Hola! Write us →',
  },
  newsletter: {
    kicker: '#goodnewsonly',
    h2: 'The best things come by mail',
    subtext1: 'Good ideas and a little Buenas-feeling straight to your inbox.',
    subtext2: 'We write about design, copy, new projects and things that inspire us.',
    placeholder: 'Your email address',
    button: 'Sign me up →',
    sending: 'One moment...',
    success: "You're in! Check your inbox soon.",
    error: 'Oops – something went wrong. Please try again.',
    privacy: 'By signing up you agree to our',
    privacyLink: 'Privacy Policy',
    privacyEnd: '.',
    captchaError: 'Please verify that you are not a robot.',
  },
  kontakt: {
    kicker: '#makeitbuenas',
    h2line1: 'How can we',
    h2line2: 'help you?',
    subtext1: "Let's talk about your brand, your idea or your project.",
    subtext2: 'Over a coffee. Or a call. Or both.',
    bookingKicker: '#bookwithus',
    bookingTitle: 'Book a call',
    bookingText: 'Pick a time that works for you and meet us on Zoom.',
    bookingButton: 'Check availability →',
    bookingIframeTitle: 'Book a call with Buenas Studio',
    bookingOpenNewTab: 'Open in new tab',
    bookingClose: 'Close',
    field1: 'Your Name',
    field2: 'Your Email',
    field3: 'Your Company / Project',
    field4: 'Tell us about your idea…',
    button: 'Send →',
    sending: 'Sending…',
    error: 'Oops – something went wrong. Please write to us directly at hi@buenas-studio.com.',
    captchaError: 'Please verify that you are not a robot.',
  },
  danke: {
    back: '← Back to homepage',
    kicker: '#hola!',
    title: 'Thanks for your message!',
    text: "We've received your request and will get back to you as soon as possible.",
    sub: 'In the meantime – feel free to keep browsing.',
  },
  impressum: {
    back: '← Back to Homepage',
    title: 'Legal Notice',
    section1: 'Information according to legal disclosure requirements',
    taxLabel: 'Tax number',
    representedBy: 'Represented by',
    responsible: 'Responsible for content',
    disclaimer: 'Disclaimer',
    liabilityContent: 'Liability for Content',
    liabilityContentText:
      'The content of our website has been created with the greatest care. However, we cannot guarantee the accuracy, completeness and timeliness of the content. As a service provider, we are responsible for our own content on these pages under the applicable general laws.',
    liabilityLinks: 'Liability for Links',
    liabilityLinksText:
      'Our website contains links to external third-party websites over whose content we have no influence. Therefore, we cannot accept any liability for this external content. The respective provider or operator of the pages is always responsible for the content of the linked pages. The linked pages were checked for possible legal violations at the time of linking. Illegal content was not recognisable at the time of linking.',
    copyright: 'Copyright',
    copyrightText:
      'The content and works created by the site operators on these pages are subject to copyright. Reproduction, processing, distribution and any type of exploitation outside the limits of copyright require the written consent of the respective author or creator.',
    dispute: 'Dispute Resolution',
    disputeText:
      'We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.',
  },
  datenschutz: {
    back: '← Back to homepage',
    title: 'Privacy Policy',
    date: 'Version: March 2026',
    s1h2: '1. Data Protection at a Glance',
    s1h3a: 'General Notes',
    s1p1: 'The following notes provide a simple overview of what happens to your personal data when you visit our website. Personal data is all data with which you can be personally identified.',
    s1h3b: 'Data Collection on Our Website',
    s1q1: 'Who is responsible for data collection on this website?',
    s1a1intro: 'Data processing on this website is carried out by the website operator:',
    s1q2: 'How do we collect your data?',
    s1a2: 'Your data is collected on the one hand by you providing it to us – for example by filling in our contact form or signing up for our newsletter. Other data is collected automatically or with your consent when you visit the website by our IT systems. This is primarily technical data (e.g. internet browser, operating system or time of page access).',
    s1q3: 'What do we use your data for?',
    s1a3: 'Some of the data is collected to ensure error-free provision of the website. Other data may be used to analyze your user behavior – provided you have given your consent.',
    s1q4: 'What rights do you have regarding your data?',
    s1a4: 'You have the right at any time to receive free information about the origin, recipient, and purpose of your stored personal data. You also have the right to request the correction or deletion of this data. If you have given consent to data processing, you can revoke this consent at any time for the future.',
    s1a4b:
      'For this and other questions on the subject of data protection, you can contact us at any time:',
    s2h2: '2. Hosting',
    s2p1: "Our website is hosted by an external service provider (host). The personal data collected on this website is stored on the host's servers. This may include IP addresses, contact requests, meta and communication data, contract data, contact details, names, website accesses, and other data.",
    s2p2: 'The host is used for the purpose of fulfilling contracts with our potential and existing customers and in the interest of a secure, fast, and efficient provision of our online offering.',
    s3h2: '3. General Notes and Required Information',
    s3h3a: 'Data Protection',
    s3p1: 'The operator of these pages takes the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with the applicable data protection regulations – in particular the Andorran data protection legislation (LQPD – Llei Qualificada de Protecció de Dades, 18/2003) as well as the European General Data Protection Regulation (GDPR), where applicable.',
    s3h3b: 'Responsible Party',
    s3p2: 'The responsible party is the natural or legal person who alone or jointly with others decides on the purposes and means of processing personal data.',
    s3h3c: 'Retention Period',
    s3p4: 'Unless a more specific retention period has been stated within this privacy policy, your personal data will remain with us until the purpose for data processing no longer applies. If you assert a legitimate request for deletion or revoke consent to data processing, your data will be deleted unless we have other legally permissible reasons for storing your personal data.',
    s3h3d: 'Your Rights',
    s3rights: [
      '<strong>Right of access</strong> – You can request information about your data stored with us.',
      '<strong>Right to rectification</strong> – You can request the correction of incorrect data.',
      '<strong>Right to erasure</strong> – You can request the deletion of your data ("right to be forgotten").',
      '<strong>Right to restriction of processing</strong> – You can request restriction of the processing of your data.',
      '<strong>Right to data portability</strong> – You can request that we transfer your data to you or a third party in a machine-readable format.',
      '<strong>Right to object</strong> – You can object to the processing of your personal data.',
      '<strong>Right to withdraw consent</strong> – If processing is based on consent, you can withdraw it at any time.',
    ],
    s3contact: 'To exercise these rights, please contact us at:',
    s4h2: '4. Data Collection on Our Website',
    s4h3a: 'Cookies',
    s4p1: 'Our website uses cookies. Cookies are small text files that your web browser stores on your device. Cookies help us make our offering more user-friendly, effective, and secure.',
    s4types: 'We distinguish between:',
    s4cookies: [
      '<strong>Technically necessary cookies</strong> – These are required for the operation of the website and cannot be disabled.',
      '<strong>Analytics cookies</strong> – These help us understand how visitors interact with the website. They are only set with your explicit consent.',
    ],
    s4p2: 'When you first visit our website, a cookie banner will ask for your consent. You can adjust your cookie settings at any time or reject all non-essential cookies.',
    s4h3b: 'Server Log Files',
    s4logp:
      'The website provider automatically collects and stores information in so-called server log files, which your browser automatically transmits to us. These are:',
    s4logs: [
      'Browser type and browser version',
      'Operating system used',
      'Referrer URL',
      'Hostname of the accessing computer',
      'Time of the server request',
      'IP address',
    ],
    s4logp2:
      'This data is not merged with other data sources. The collection of this data is based on legitimate interests (Art. 6 para. 1 lit. f GDPR) – the technically error-free operation of the website.',
    s4h3c: 'Contact Form',
    s4contactp1:
      'If you send us inquiries via the contact form, your details from the inquiry form, including the contact details you provided there, will be stored by us for the purpose of processing the inquiry and in case of follow-up questions. We do not share this data without your consent.',
    s4contactp2:
      'The processing of this data is based on Art. 6 para. 1 lit. b GDPR, if your request is related to the performance of a contract or is necessary for the implementation of pre-contractual measures. In all other cases, processing is based on our legitimate interest in the effective processing of requests addressed to us (Art. 6 para. 1 lit. f GDPR) or on your consent (Art. 6 para. 1 lit. a GDPR).',
    s4storedLabel: 'Data stored:',
    s4storedValue: 'Name, email address, company/project, message content',
    s4retentionLabel: 'Retention period:',
    s4retentionValue: 'Until final processing of your inquiry, maximum 3 years',
    s5h2: '5. Analytics Tools',
    s5h3: 'Google Analytics',
    s5p1: 'This website uses Google Analytics, a web analytics service provided by Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland ("Google"). Google Analytics uses cookies that enable an analysis of your use of the website.',
    s5ipLabel: 'IP anonymization:',
    s5ipText:
      'We have activated the IP anonymization feature on this website. This means your IP address will be truncated by Google within member states of the European Union or in other contracting states of the Agreement on the European Economic Area before transmission to the USA.',
    s5consent:
      'Google Analytics is only used after your explicit consent via our cookie banner (Art. 6 para. 1 lit. a GDPR).',
    s5contractLabel: 'Data processing agreement:',
    s5contractText:
      'We have concluded a data processing agreement with Google and fully implement the strict requirements of the data protection authorities when using Google Analytics.',
    s6h2: '6. Social Media',
    s6h3: 'Instagram',
    s6p1: "Our website embeds content from the social network Instagram (Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2, Ireland). When you visit our page, a connection to Instagram's servers may be established through the embedded Instagram content.",
    s6p2: 'The embedding of Instagram content is based on your consent (Art. 6 para. 1 lit. a GDPR) or on the basis of our legitimate interest in an appealing presentation of our online offering (Art. 6 para. 1 lit. f GDPR).',
    s7h2: '7. Newsletter',
    s7p1: 'If you would like to receive the newsletter offered on the website, we need an email address from you as well as information that allows us to verify that you are the owner of the email address provided and that you agree to receive the newsletter (double opt-in procedure).',
    s7storedLabel: 'Data stored:',
    s7storedValue: 'Email address, first name (optional), date of registration',
    s7purposeLabel: 'Purpose:',
    s7purposeValue: 'Sending the newsletter',
    s7legalLabel: 'Legal basis:',
    s7legalValue: 'Consent (Art. 6 para. 1 lit. a GDPR)',
    s7unsubscribe:
      'You can unsubscribe from the newsletter at any time via the unsubscribe link in the newsletter or by email to hi@buenas-studio.com.',
    s8h2: '8. Plugins and Tools',
    s8h3: 'Google Fonts',
    s8p1: 'This site uses so-called web fonts for the uniform display of fonts, which are provided by Google. When a page is accessed, your browser loads the required web fonts into its browser cache in order to display texts and fonts correctly.',
    s8p2: 'The use of Google Web Fonts is based on Art. 6 para. 1 lit. f GDPR. We have a legitimate interest in the uniform presentation of the typeface on our website.',
    s9h2: '9. Changes to This Privacy Policy',
    s9p: 'We reserve the right to adapt this privacy policy so that it always complies with current legal requirements or to implement changes to our services in the privacy policy.',
    s10h2: '10. Contact for Data Protection Issues',
    footernote: 'Buenas Studio · buenas-studio.com · hi@buenas-studio.com · Version: March 2026',
  },
  footer: {
    subtitle: 'Studio for Design & Text',
    tagline: 'good. better. buenas.',
    locations: 'Andorra · Austria · World',
    copyright: '© 2026 Buenas Studio',
    link1: 'Legal Notice',
    link2: 'Privacy Policy',
  },
  whatsapp: {
    greeting: 'Buenas!',
    text: 'How can we help you? Feel free to write to us!',
    send: 'Send message →',
    prefill: 'Hi! I have an idea...',
  },
  seo: {
    home: {
      title: 'buenas studio – Studio for Design, Copy & Software',
      description:
        'Design, copywriting, and software development from Andorra and Lake Constance. Corporate design, branding, copy, websites, and custom software – creative and professional.',
    },
    legal: {
      title: 'Legal Notice – buenas studio',
      description:
        'Legal notice and company information for buenas studio. Christina Mathis – Marketing & IT Services, Encamp, Andorra.',
    },
    privacy: {
      title: 'Privacy Policy – buenas studio',
      description:
        'Privacy policy of buenas studio. Information on the collection and processing of personal data.',
    },
    thanks: {
      title: 'Thank You – buenas studio',
      description: 'Thank you for your message! We will get back to you as soon as possible.',
    },
    notFound: {
      title: 'Page Not Found – buenas studio',
      description: 'This page does not exist. Go back to the buenas studio homepage.',
      h1: 'Page not found',
      text: "Oops – this page doesn't exist.",
      back: '← Back to homepage',
    },
  },
}

export default en
